import React, { Component } from 'react';
import { Panel, PanelType } from 'office-ui-fabric-react';
import { MessageBars } from '../Outils/MessageBars';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Immocom } from '../../specifique/immocom';
import Scriba from 'react-scriba';
import { EUITextField } from '../EUI/EUITextField';
import { MaxLengths } from '../../data/MaxLenghts';
import { DataProgramme } from '../../data/DataProgramme.jsx';
import { ComboBoxTrancheTravaux } from '../ComboBox/ComboBoxTrancheTravaux';

var objetState = {
    nomenclature: {},
    items: [],
    idTrancheTravaux: 0,

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',

    onActiveBoutonEnregistrer: false,
};

export class FicheProgrammeNomenclatureOperis extends Component {

    _creationContent() {
        let titrePanel = (this.props.idNomenclature === 0) ? 'Création de la nomenclature' : 'Edition de la nomenclature';

        return <Panel
            closeButtonAriaLabel="Fermer"
            headerText={titrePanel}
            isOpen={this.props.onAffichePanelNomenclatureOperis}
            onDismiss={this._onAnnulation}
            onOpen={this._onOpen}
            onRenderFooterContent={this._onRenderFooterContent}
            type={PanelType.smallFixedFar}
        >
            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />
            <EUITextField
                label="Société"
                maxLength={MaxLengths.operisNomenclature.societe}
                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "nomenclature", "societe", newValue, this._onVerificationFormulaire)}
                required
                value={this.state.nomenclature.societe}
            />
            <EUITextField
                label="Entité"
                maxLength={MaxLengths.operisNomenclature.entite}
                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "nomenclature", "entite", newValue, this._onVerificationFormulaire)}
                required
                value={this.state.nomenclature.entite}
            />
            <EUITextField
                label="Projet"
                maxLength={MaxLengths.operisNomenclature.projet}
                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "nomenclature", "projet", newValue, this._onVerificationFormulaire)}
                required
                value={this.state.nomenclature.projet}
            />
            <EUITextField
                label="Activité"
                maxLength={MaxLengths.operisNomenclature.activite}
                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "nomenclature", "activite", newValue, this._onVerificationFormulaire)}
                required
                value={this.state.nomenclature.activite}
            />
            <ComboBoxTrancheTravaux
                idProgramme={this.props.idProgramme}
                onChange={(event, option) => Scriba.state().setObjetPropriete(this, "nomenclature", "idTrancheTravaux", option.key, this._onVerificationFormulaire)}
                required
                selectedKey={this.state.nomenclature.idTrancheTravaux}
            />
        </Panel>;
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(
            objetState
        );
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement de la nomenclature en cours'
        });

        const objet = {
            ...this.state.nomenclature,
            idNomenclature: this.props.idNomenclature,
            idProgramme: this.props.idProgramme,
            idRegion: this.props.idRegion,
            idAgence: this.props.idAgence
        };

        var enregistrementNomenclature = DataProgramme._onEnregistrementOperisNomenclature(objet);

        enregistrementNomenclature
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    this.props.onEnregistrementFiche();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onOpen = () => {
        if (this.props.idNomenclature) {
            this._chargementFicheEnModeModification();
        }
        else {
            this._chargementFicheEnModeCreation();
        }
    };

    _chargementFicheEnModeCreation() {
        this.setState({
            nomenclature: {},
            idNomenclature: 0,
            enCoursDeTraitement: false,
            messageEnCoursTraitement: ''
        });
    }

    _chargementFicheEnModeModification() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement de la nomenclature'
        });

        var chargementOperisNomenclature = DataProgramme._chargementFicheProgrameOperisNomenclature(this.props.idNomenclature);

        chargementOperisNomenclature.then(
            responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let nomenclature = responseFetch.reponseAPIobjet;

                    let stateTemp = {};
                    stateTemp.nomenclature = nomenclature;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);

                    this.setState({
                        enCoursDeTraitement: false,
                        onActiveBoutonEnregistrer: true
                    });
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    };

    _onVerificationFormulaire() {
        Immocom.fiche()._validationFormulaire(this, 'OperisNomenclature', this.state.nomenclature, (this.state.nomenclature.idNomenclature > 0 ? 'Modification' : 'Création'));
    }

    _onRenderFooterContent = () => {
        const boutonActif = this.state.onActiveBoutonEnregistrer;
        return (
            <div>
                <PrimaryButton onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!boutonActif}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    render() {
        return this._creationContent();
    }

}